<template>
  <div>
    <v-navigation-drawer
      app
      style="border-right: solid 1px #e0e0e0; padding-top: 36px;"
      v-if="!shouldHideDrawer"
      permanent
    >
      <template v-slot:prepend>
        <div class="d-flex justify-center" style="margin: 8px;">
          <v-img
            class="mx-auto"
            height="40px"
            width="68%"
            src="@/assets/CCS_Logo.png"
          ></v-img>
        </div>
        <v-divider />
      </template>

      <div>
        <v-list nav v-if="currentSchool">
          <div v-for="(menu, m) in navMenuItems" :key="m">
            <div v-if="shouldShowMenuHeader(menu)" class="menu-header">
              {{ $t(menu.i18nKey) }}
            </div>
            
            <template
              v-for="(item, i) in currentSchool?.applicationPlan.nurseryWeb.featureGroups.find(
                (f) => f.name == menu.name
              )?.features"
              :key="i"
            >
              <v-list-item
                v-if="menu.features.some((m) => m.slug === item.slug)"
                :to="menu.features.find((m) => m.slug == item.slug)?.path"
                :active="isMenuActive(menu.features.find((m) => m.slug == item.slug)?.path)"
                :style="item.isEnabled ? '' : 'display: none;'"
                :target="menu.features.find((m) => m.slug == item.slug)?.target"
                :href="menu.features.find((m) => m.slug == item.slug)?.href"
                density="compact"
                link
                color="primary"
                class="pl-2"
              >
                <v-list-item-title>{{ $t(`features.${item.slug}`) }}</v-list-item-title>
              </v-list-item>
            </template>
          </div>
        </v-list>

        <v-progress-linear color="primary" class="pa-1" indeterminate v-else />
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script lang="ts">
import { meModule } from "@/store/dataModules/meModule";
import { MeNurserySchoolResponse, MeResponse } from "chaild-api/lib";
import { defineComponent } from "vue";
import { navMenuItems } from "@/constants/navigation";

export default defineComponent({
  name: "NavigationDrawer",

  data() {
    return {
      navMenuItems: navMenuItems,
    };
  },

  computed: {
    shouldHideDrawer() {
      if (
        this.$route.path === "/attendance/management" ||
        this.$route.path === "/staffAttendance/management" ||
        this.$route.path === "/maintenance" ||
        (this.$route.path.startsWith("/nap/") &&
          this.$route.path.endsWith("detail")) ||
        (this.$route.path.startsWith("/nap/") &&
          this.$route.path.endsWith("sensor")) ||
        this.$route.name == "CashBookTable"
      ) {
        return true;
      }
      return false;
    },
    me: function (): MeResponse | null {
      return meModule.me;
    },
    nurseryId: function (): number | null {
      return meModule.nurseryId;
    },
    currentSchool: function (): MeNurserySchoolResponse | null {
      if (this.me && this.nurseryId) {
        const currentSchool = this.me.nurserySchools.find((s) => {
          return s.nurseryId == this.nurseryId;
        });
        return currentSchool ?? null;
      } else {
        return null;
      }
    },
    isAdmin: function (): boolean {
      return !!this.currentSchool?.isAdmin;
    },
    username: function (): string | null {
      if (this.currentSchool) {
        return `${this.currentSchool?.lastName || ""} ${
          this.currentSchool?.firstName || ""
        }`;
      } else {
        return null;
      }
    },
  },

  methods: {
    openNewTab(value: string) {
      window.open(value, "_blank");
    },
    // Keep parent menu highlighted on nested routes (e.g. /ai-report/quarter/...)
    isMenuActive(path?: string): boolean {
      if (!path) return false;
      const current = this.$route.path;
      return current === path || current.startsWith(path + "/");
    },
    shouldShowMenuHeader(menu: any): boolean {
      if (this.currentSchool) {
        const featureGroup = (
          this.currentSchool as any
        )?.applicationPlan?.nurseryWeb?.featureGroups.find(
          (f: any) => f.name === menu.name
        );

        if (!featureGroup || !featureGroup.features) return false;

        // API側で有効(isEnabled) かつ (navMenuItems)にslugが存在するものだけカウント
        const enabledMenus = featureGroup.features.filter((f: any) => {
          return f.isEnabled && menu.features.some((m: any) => m.slug === f.slug);
        });

        return enabledMenus.length > 0;
      } else {
        return false;
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.menu-header {
  color: #029ec0;
  font-weight: bold;
  font-size: 14px;
  margin-top: 16px;
  margin-bottom: 4px;
  padding: 4px 8px;
  border-bottom: solid 1px #029ec0;
}

:deep(.v-navigation-drawer__content) {
  scrollbar-gutter: stable;
}

:deep(.v-list-item-title) {
  line-height: 1.5;
}
</style>
